import { render, staticRenderFns } from "./routeDropdown.vue?vue&type=template&id=81167a08&scoped=true"
import script from "./routeDropdown.vue?vue&type=script&lang=js"
export * from "./routeDropdown.vue?vue&type=script&lang=js"
import style0 from "./routeDropdown.vue?vue&type=style&index=0&id=81167a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81167a08",
  null
  
)

export default component.exports